/* eslint-disable react/jsx-no-undef */
import * as React from 'react'
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { AboutUsContent, BaseDiv, DoubleInput, TextBody, TextContent } from './styles';
import Input from '../../../../Input';
import Button from '../../../../Button';
import FormService from '../../../../../services/form';
import { useToast } from '../../../../../hooks/toast';

interface INavBar {
    
}
const formService = new FormService();

const Formulario: React.FC<INavBar> = () => {

    const formRef = React.useRef<FormHandles>(null);
  const { addToast } = useToast();

  const handleSubmit = React.useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});
        const response = await formService.postContato({
          origin: 'site',
          name: data.name,
          email: data.email,
          phone: data.phone,
          name_company: data.name_company,
        });
        addToast({
          type: 'success',
          title: 'Formulário enviado',
          description: 'Formulário enviado com sucesso',
        });
        formRef.current?.reset();
      } catch (err: any) {
        console.log(err);
        addToast({
          type: 'error',
          title: 'Erro ao enviar o formulário',
          description: 'Verifique se todos os campos estão preenchidos corretamente.',
        });
      }
    },
    [addToast]
  );

    return (
        <BaseDiv>
            <AboutUsContent>
                <TextContent>
                    <TextBody>
                        <Form ref={formRef} onSubmit={handleSubmit} placeholder={undefined}>
                            <Input name='name' label='NOME'/>
                            <Input name='email' label='E-MAIL'/>
                            <DoubleInput>
                                <Input name='phone' label='TELEFONE' />
                                <Input name='name_company' label='EMPRESA'/>
                            </DoubleInput>
                            <Button color='orange' padding={'10px'}type="submit">
                                ENVIAR
                            </Button>
                        </Form>
                    </TextBody>
                </TextContent>
            </AboutUsContent>
        </BaseDiv>
    );
}

export { Formulario }